import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { WaterIntake_EndPoint } from "./ConstantsHealthCalculator";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de consommation d'eau";
const DESCRIPTION =
  "Calculatrice de consommation d en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de consommation d, calculatrice de consommation d, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/water-intake/";
const apiEndpoint = `${SERVER_URL}/${WaterIntake_EndPoint}`;

function WaterIntakeCalculator() {
  const [weight, setWeight] = useState("");
  const [activity, setActivity] = useState("light");
  const [climate, setClimate] = useState("moderate");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const calculateWaterIntake = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, activity, climate }),
      });
      const data = await response.json();
      if (response.ok) {
        setResult(data.result);
        setError(null);
      } else {
        setResult(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
      setError("Erreur lors du calcul");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  L'eau est essentielle à la vie et à la santé. Bien que la quantité d'eau que vous devez boire dépende de plusieurs facteurs, une règle générale est de boire environ 8 verres d'eau par jour. Cependant, vos besoins en eau peuvent varier en fonction de votre poids, de votre niveau d'activité physique et du climat dans lequel vous vivez.
                </p>
                <p>
                  Utilisez cette calculatrice pour déterminer la quantité d'eau que vous devriez consommer quotidiennement pour maintenir une bonne hydratation.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Calculatrice de consommation d'eau
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weight" className="form-label ms-2">
                      Poids
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weight"
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="70"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="activity" className="form-label ms-2">
                      Activité
                    </label>
                  </b>
                  <select
                    id="activity"
                    value={activity}
                    onChange={(e) => setActivity(e.target.value)}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="light">Légère</option>
                    <option value="moderate">Modérée</option>
                    <option value="intense">Intense</option>
                  </select>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="climate" className="form-label ms-2">
                      Climat
                    </label>
                  </b>
                  <select
                    id="climate"
                    value={climate}
                    onChange={(e) => setClimate(e.target.value)}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="cool">Frais</option>
                    <option value="moderate">Modéré</option>
                    <option value="hot">Chaud</option>
                  </select>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateWaterIntake}
                    disabled={isLoading}
                  >
                    {isLoading ? "Calcul..." : "Calculer"}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <div className="p-3 mb-2 bg-info">
                  <h3>Recommandations de consommation d'eau</h3>
                  <p>La quantité d'eau recommandée dépend de plusieurs facteurs. Cette calculatrice tient compte de votre poids, votre activité physique et votre climat.</p>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="row">
                <div className="col">
                  {error && (
                    <div className="alert alert-warning">
                      <b>
                        <u> Erreur :</u>
                      </b>{" "}
                      {error}{" "}
                    </div>
                  )}
                  {result && (
                    <div>
                      <h4>Résultats :</h4>
                      <hr />
                      <div className="alert alert-success">
                        <label>
                          <b> Consommation d'eau recommandée : </b>
                          {result.waterIntake} litres par jour
                        </label>
                      </div>
                      <div className="alert alert-success">
                        <label>
                          <b> Nombre de verres : </b>
                          {Math.round(result.waterIntake * 4)} verres
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Pourquoi s'hydrater suffisamment ?</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Combien d'eau faut-il boire ?</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WaterIntakeCalculator;